export default class ParticleStats {
  public static emitterCount: number = 0;
  public static drawCalls: number = 0;

  public static reset(): void {
    ParticleStats.emitterCount = 0;
    ParticleStats.drawCalls = 0;
  }
}
